export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-emotion-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
];

export const movieTags = [
  '动作', '喜剧', '爱情', '科幻', '悬疑', '恐怖', '战争', '武侠',
  '奇幻', '动画', '剧情', '纪录片', '犯罪', '冒险', '古装', '都市',
];

export const regionTags = ['中国大陆', '中国香港', '中国台湾', '韩国', '日本', '美国', '英国', '法国', '印度', '泰国'];

export const yearOptions = ['2026', '2025', '2024', '2023', '2022', '2021', '2020', '2019', '2018', '2010-2017', '2000-2009', '2000年以前'];